import React from 'react'
import './aboutme.css'
import './aboutme_desktop.css'


export default function AboutMe() {

    return (
        <React.Fragment>
            <br /><br />
            <div className="main-content">
                <br />
                <h1>About Me</h1> 
                <section className="aboutme">
                    <img style={{ float: 'left' }} src="/img/aboutme/market_booth.jpeg" alt="farmers market booth" />
                    <p>I started crocheting during the pandemic (like many people, oops!). I started out thinking amigurumi/plushies would be my thing, but quickly realized I am drawn toward making accessories and apparel way more!</p>
                    <p>I enjoy making unique pieces, and never really make two of the exact same thing unless there’s a big demand for certain colors. Scrap yarn and leftover skeins make for great one-of-a-kind items that are basically impossible to replicate.</p>
                    <p>In the beginning of summer 2025, I started doing local farmers markets and LOVED it. I did markets through the fall and then a couple around Christmas, and I’m excited to get back into it this year! I bought a new (to me) canopy that will really elevate my booth, and I might even branch out and do more than just farmers markets.</p>
                    <h5 style={{ fontWeight: 'bolder', fontStyle: 'italic', fontSize: 'medium', textAlign: 'center' }}>Here are some more random fun facts about me! </h5>
                </section>
                <section className="list-section">
                    <img style={{ float: 'right', height: 300 }} src="/img/aboutme/mika.jpg" alt="Mika, the grumpy cat" />
                    <div className="list-section-item">
                        <span className="item-number">1.</span>
                        <p>I LOVE CATS. I have a cat named Mika, named after the singer. Is she “mine” though if she lives at my parents’ house? :/</p>
                    </div>
                    <div className="list-section-item">
                        <span className="item-number">2.</span>
                        <p>I grew up dancing and playing the violin. I started dance at age 3, and violin at age 5. I participated in school and community orchestras, and I even performed violin with The Piano Guys at one of their concerts at the USANA amphitheater!</p>
                    </div>
                </section>
                <section className="list-section">
                    <img style={{ float: 'left' }} src="/img/aboutme/korea_trip.jpg" alt="Mika, the grumpy cat" />
                    <div className="list-section-item">
                        <span className="item-number">3.</span>
                        <p>I think languages are fascinating and I have been self studying Korean since 2016. I went on a study abroad to South Korea in 2019 and attended a Korean university for one semester.</p>
                    </div>
                    <div className="list-section-item">
                        <span className="item-number">4.</span>
                        <p>Speaking of Korea… I am a huge lover of k-pop! I’m not as intense of a fan as I used to be, but back in the day I had a blast fangirling with my mom and my aunt, attending concerts and putting in work on a YouTube channel that is now dead.</p>
                    </div>
                </section>
                <section className="list-section">
                    <img style={{ float: 'right', height: 300 }} src="/img/aboutme/market_booth_2.jpeg" alt="Mika, the grumpy cat" />
                    <div className="list-section-item">
                        <span className="item-number">5.</span>
                        <p>When I was a kid, my mom and I had a dream of starting an Etsy shop called The “B” Boutique, selling anything we could craft up that started with B: beanies, bubble magnets, or belly bags, to name a few. That never happened, but I’ve always had this idea in the back of my mind to have a crafty business and sell online or at markets…. And now I have Crochetedly!</p>
                    </div>
                </section>
                <br />
                <section>
                    <p style={{ fontSize: 'large', fontWeight: 'bold' }}>Thank you so much for being here!</p>
                </section>
                <br />
            </div>
            <br /><br />
        </React.Fragment>
    )
}